import React, { useState } from "react";
import styled from "styled-components";
import { Styles } from "../config";

import { normalizeString } from "../util/functions";

const Vessel = styled.button`
  position: relative;
  display: flex;

  align-items: center;
  justify-content: center;
  width: ${(props) => props.width || "auto"};
  margin: ${(props) => props.margin || "10px 20px"};
  background: ${(props) =>
    props.color ? Styles.Color[props.color] : Styles.Color.secondary};
  cursor: pointer;
  font-size: ${(props) =>
    props.variant
      ? Styles.FontSize[props.variant].size
      : Styles.FontSize.t6.size};

  height: 60px;
  padding: 7px 20px;
  width: auto;
  border-radius: 7px;
  border: 0px;
  font-weight: 600;
  color: white;
  transition: all 300ms ease-in-out;

  &:not([disabled]):hover {
    background: ${(props) =>
    props.color === "primary"
      ? Styles.Color.secondary
      : Styles.Color.primary};
    color: white;
  }

  &:disabled {
    cursor: not-allowed !important;
  }
`;

const Button = (props) => {
  const [hovering, setHover] = useState(false);

  const { text, type, children, width, margin, id, disabled, style, form } =
    props;
  const { onClick } = props;
  return (
    <Vessel
      id={id || null}
      form={form || null}
      type={type || "button"}
      onClick={!type || type === "button" ? onClick : null}
      disabled={disabled}
      style={style}
      margin={margin}
      width={width}
      color={props.color}
    >
      {text ? normalizeString({ data: text, actions: ["nobreak"] }) : text}

      {children && children}
    </Vessel>
  );
};

export default Button;
